export class DateUtils {
  static parseDate(value: string | number | Date): Date {
    const date = DateUtils.parseDateTime(value);
    if (date) {
      date.setHours(0);
      date.setMinutes(0);
      date.setSeconds(0);
      date.setMilliseconds(0);
    }

    return date;
  }

  static parseDateTime(value: string | number | Date): Date {
    if (value) {
      return new Date(value);
    }

    return null;
  }
}
